import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { ExternalLinkStyles } from './ExternalLink.styles';
/**
 * Themeable link component using <a> tag that links out to an external webpage
 *
 * ```js
 * import { ExternalLink } from '@minerva-analytics/pantheon';
 * <ExternalLink href='https://minervaanalytics.co/'> Minerva Analytics </ExternalLink>
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [ExternalLink.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/ExternalLink/ExternalLink.styles.js)
 *
 */

export var ExternalLinkComponent = function ExternalLinkComponent() {
  return /*#__PURE__*/React.createElement(ExternalLinkStyles, null);
};
var ExternalLink = createThemedComponent('ExternalLink', ExternalLinkStyles);
export default ExternalLink;